import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { MESSAGES } from "~/resources/Message";
import { FormCloudEnvironment} from "~/models/Commons ";
import { useSaveCloudEnvironmentMutation, useUpdateCloudEnvironmentMutation } from "~/services/cloudenvironment";
import { useGetProvidersQuery } from "~/services/providers";

export const UseFormCloudEnvironment = (
  onCloseModal: () => void,
  refetch: () => void,
  id:number
) => {
 
  const [saveCloudEnvironment, { isLoading }] = useSaveCloudEnvironmentMutation();
  const [updateCloudEnvironment] = useUpdateCloudEnvironmentMutation();
 const { data:provider } = useGetProvidersQuery();
  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    setValue
  } = useForm<FormCloudEnvironment>({
    defaultValues: {
      environmentName:  "",
      environmentDescription:  "",
      datacenterName:"",
      datacenterDescription:"",
      location:  "",
      cloudProviderId:undefined,
      iac:"",
      authenticationConfig:"",
    },
  });

  const submitForm = async (_data: FormCloudEnvironment) => {
    try {
      const parsedData: FormCloudEnvironment = {
        ..._data,
        cloudProviderId: _data.cloudProviderId.value,
      };
  
      const response = await saveCloudEnvironment(parsedData).unwrap();
      if (response.success) {
        toast.success(response?.message);
        refetch();
      } else {
        throw new Error('Save operation failed: No success response');
      }
    } catch (error: any) {
      const errorMessageTitle =
      error?.data?.title || error?.title || MESSAGES.MessageErrorUpdatingCloudEnvironment;
      const errorMessageStstus =
      error?.data?.status || error?.status || MESSAGES.MessageErrorUpdatingCloudEnvironment;
      toast.error(`Status:${errorMessageStstus}\nTitle:${errorMessageTitle}`);
      console.error('Error', error);
    } finally {
      refetch();
      onCloseModal();
      console.log('submitForm: completed');
    }
  };
   
  
  const updateForm = async (_data: FormCloudEnvironment) => {
    if (!id) {
      toast.error("Missing environment ID for update.");
      return;
    }
  
    const parsedData: FormCloudEnvironment = {
      ..._data,
      cloudProviderId: _data.cloudProviderId.value,
    };
  
    try {
      const response = await updateCloudEnvironment({
        id,
        data: parsedData,
      }).unwrap();
  
      if (response.success) {
        toast.success(response?.message);
        refetch();
      } else {
        throw new Error('Save operation failed: No success response');
      }
    } catch (error: any) {
      const errorMessageTitle =
        error?.data?.title || error?.title || MESSAGES.MessageErrorSavingCloudEnvironment;
        const errorMessageStstus =
        error?.data?.status || error?.status || MESSAGES.MessageErrorSavingCloudEnvironment;
        toast.error(`Code:${errorMessageStstus}\n Title:${errorMessageTitle}`);
      console.error('Error', error);
    } finally {
      refetch();
      onCloseModal();
      console.log('submitForm: completed');
    }
  };
  
  
  
  return {
    handleSubmit,
    control,
    errors,
    submitForm,
    updateForm,
    isLoading,
    reset,
    setValue,
    provider,
  };
};